import type { ModalFooterModel } from "../../type/modal";

export const ModalFooter: React.FC<ModalFooterModel> = ({ children }) => (
  <div className="modal-footer">{children}</div>
);
